module.exports = __webpack_public_path__ + "app/web/assets/images/referral1.png";